export const DEFAULT_NO_EMAIL_BASE = "policyholder+";
